export const delay = (ms: number): Promise<void> => {
  // eslint-disable-next-line no-restricted-globals -- Promise 기반 유틸, 훅 사용 불가
  return new Promise(resolve => setTimeout(resolve, ms));
};
